module.exports = __webpack_public_path__ + "img/RoterMann,ManOnFire.0000ec73.jpg";